import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from './auth-context'

/** Where a person whose first login th_saas refused is sent (UC-084.1 BR2). */
export const INVITATION_REFUSED_PATH = '/invitation?outcome=invalid'

interface AuthGuardProps {
  children: React.ReactNode
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isInitialized, identityRefusal, login } = useAuth()
  const needsLogin = isInitialized && !isAuthenticated && identityRefusal === null

  useEffect(() => {
    if (needsLogin) {
      void login()
    }
  }, [needsLogin, login])

  // A refused identity must never bounce back into the B2C login: the person
  // has a live session that th_saas will refuse again on the next request. The
  // outcome page explains what happened and offers to sign out.
  if (identityRefusal !== null) {
    return <Navigate to={INVITATION_REFUSED_PATH} replace />
  }

  if (!isInitialized || !isAuthenticated) {
    return null
  }

  return <>{children}</>
}
